import { fetchInsight, fetchLifetime, fetchPending, fetchProgress, fetchProgressReport, fetchRecovery, fetchRetrospective, } from "./api";
import { pendingKeys, progressKeys } from "./keys";
/**
 * The progress domain as option objects (`../core/options.ts`). The app
 * spreads them into its hooks; nothing here knows about React or TanStack.
 */
/** The Progress screen's aggregates, for one range and locale (T33). */
export function progressOptions(api, options = {}) {
    return {
        queryFn: ({ signal }) => fetchProgress(api, options, { signal }),
        queryKey: progressKeys.aggregates(options.weeks, options.locale),
    };
}
/** The Retrospectiva's cards, for one week (the last complete one when
 *  omitted) and locale (T34). */
export function retrospectiveOptions(api, options = {}) {
    return {
        queryFn: ({ signal }) => fetchRetrospective(api, options, { signal }),
        queryKey: options.period === "month" || options.period === "year"
            ? progressKeys.retrospectivePeriod(options.period, options.period === "month" ? options.month : options.year, options.locale)
            : progressKeys.retrospective(options.week, options.locale),
    };
}
/** Muscle readiness, for one locale (`D203`). */
export function recoveryOptions(api, options = {}) {
    return {
        queryFn: ({ signal }) => fetchRecovery(api, options, { signal }),
        queryKey: progressKeys.recovery(options.locale),
    };
}
/** The lifetime totals and the achievements (`D204`). */
export function lifetimeOptions(api) {
    return {
        queryFn: ({ signal }) => fetchLifetime(api, { signal }),
        queryKey: progressKeys.lifetime,
    };
}
/** The Today insight card, for one locale (T36). */
export function insightOptions(api, options = {}) {
    return {
        queryFn: ({ signal }) => fetchInsight(api, options, { signal }),
        queryKey: progressKeys.insight(options.locale, options.language),
    };
}
/**
 * The pending signals (T38), keyed `["pending"]` — `pendingKeys.all` from
 * `data/plan/keys.ts`, the prefix the draft writes (T32), the session end and
 * "seen" (T37) already invalidate. No locale: nothing in it is localized.
 */
export function pendingOptions(api) {
    return {
        queryFn: ({ signal }) => fetchPending(api, { signal }),
        queryKey: pendingKeys.all,
    };
}
/** The progress report, for one span (the last ended one when its name is
 *  omitted) and locale (`D252`). */
export function progressReportOptions(api, options = {}) {
    const period = options.period ?? "week";
    return {
        queryFn: ({ signal }) => fetchProgressReport(api, options, { signal }),
        queryKey: progressKeys.report(period, period === "month" ? options.month : options.week, options.locale),
    };
}
//# sourceMappingURL=options.js.map